import { Building2, Layers, Truck, BarChart3 } from 'lucide-react';
import type { ViewOption } from './InsightsViewSelector';

export type EntityView = 'reporting-levels' | 'assets' | 'sectors' | 'suppliers';

export const ENTITY_VIEW_OPTIONS: ViewOption<EntityView>[] = [
  { key: 'assets', label: 'Assets', Icon: Building2, iconBg: 'tw:bg-emerald-100', iconColor: 'tw:text-emerald-600' },
  { key: 'reporting-levels', label: 'Reporting Levels', Icon: Layers, iconBg: 'tw:bg-blue-100', iconColor: 'tw:text-blue-600' },
  { key: 'sectors', label: 'Sectors', Icon: BarChart3, comingSoon: true },
  { key: 'suppliers', label: 'Suppliers', Icon: Truck, comingSoon: true },
];
